import React, { useContext, useState } from 'react';
import { motion } from 'framer-motion';
import { ThemeContext } from '../context/ThemeContext';

const cardVariants = {
    hidden: { opacity: 0, scale: 0.8, rotate: 10 },
    visible: {
        opacity: 1,
        scale: 1,
        rotate: 0,
        transition: { type: 'spring', stiffness: 120 }
    }
};

const SocialLinks = ({ socialId, imgSrc, linkURL }) => {
    const { theme, themes } = useContext(ThemeContext);
    const [isHovered, setIsHovered] = useState(false);

    // Dynamically set imgSrc based on theme's isIconDark property
    const imgSource = themes[theme].isIconDark
        ? `${imgSrc}_dark.png`
        : `${imgSrc}_light.png`;

    // Define the glow color based on the theme or use a default color
    const glowColor = `${themes[theme].glowColor}`;

    return (
        <motion.div
            // w-14 locks the width horizontally
            // pb-7 reserves the vertical space for the absolute label below
            className="zoom relative flex flex-col items-center justify-center w-14 mt-6 pb-7"
            variants={cardVariants}
            whileHover={{ scale: 1.1, rotate: -5 }}
            transition={{ duration: 0.2 }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <a 
                href={linkURL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="relative flex flex-col items-center"
                onFocus={() => setIsHovered(true)}
                onBlur={() => setIsHovered(false)}
            >
                <motion.img
                    src={imgSource}
                    alt={`${socialId} icon`}
                    className="social-icon"
                    style={{
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        cursor: 'pointer',
                        boxShadow: isHovered
                            ? `0 0 15px ${glowColor}, 0 0 30px ${glowColor}, 0 0 45px ${glowColor}`
                            : 'none',
                        transition: 'box-shadow 0.3s ease',
                    }}
                    whileHover={{ scale: 1.2 }}
                    loading="eager"
                />

                {/* Absolute label won't push adjacent icons, but pb-7 above preserves the distance to the Resume button */}
                <motion.div
                    initial={{ opacity: 0, y: -4 }}
                    animate={isHovered ? { opacity: 1, y: 0 } : { opacity: 0, y: -4 }}
                    transition={{ duration: 0.25 }}
                    className={`social-id-label absolute top-full mt-2 pointer-events-none whitespace-nowrap ${themes[theme].text}`}
                    style={{
                        fontSize: '13px',
                        fontWeight: 'bold',
                    }}
                >
                    {socialId}
                </motion.div>
            </a>
        </motion.div>
    );
};

export default SocialLinks;
